<div id="error" [class]="active ? 'active' : ''" [dir]="currentLang.dir">
    <div id="error-content">
        <div id="error-message">{{currentLang.words["error"]}}</div>
        <div id="error-code" [innerHTML]="error"></div>
        <!-- Technical details stay LTR: ids, timestamps and urls are unreadable when mirrored. -->
        <div id="error-details" dir="ltr" *ngIf="details">
            <div class="error-detail">
                <span class="error-detail-label">{{currentLang.words["error_time"]}}</span>
                <span class="error-detail-value">{{details.time}}</span>
            </div>
            <div class="error-detail" *ngIf="details.companyId">
                <span class="error-detail-label">{{currentLang.words["error_company"]}}</span>
                <span class="error-detail-value">{{details.companyId}}</span>
            </div>
            <div class="error-detail" *ngIf="details.userId">
                <span class="error-detail-label">{{currentLang.words["error_user"]}}</span>
                <span class="error-detail-value">{{details.userId}}</span>
            </div>
            <div class="error-detail">
                <span class="error-detail-label">{{currentLang.words["error_version"]}}</span>
                <span class="error-detail-value">{{details.version}} ({{details.platform}})</span>
            </div>
        </div>
        <div id="error-actions">
            <div class="error-action" *ngIf="details" (click)="copyDetails()">
                {{copied ? currentLang.words["error_copied"] : currentLang.words["error_copy"]}}
            </div>
            <div class="error-action" routerLink="/" (click)="close()">{{currentLang.words["reload"]}}</div>
        </div>
    </div>
    <div id="error-close" (click)="close();"><span></span></div>
</div>
